<template>
  <v-layout>
    <v-flex md mt-5>
      <v-card
        class="mx-auto elevation-4 mt-5"
        max-width="500"
        :dark="config.dark_background"
        :color="config.background_dark"
      >
        <v-toolbar
          v-bind:color="config.primary"
          dark
          flat
        >
          <v-toolbar-title>
            <v-icon>mdi-account-arrow-right</v-icon> Login
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
          icon
          large
          @click="navigateTo({name: 'home'})"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-toolbar>
        <v-spacer />
        <v-alert
        class="my-4 mx-4"
        v-if="error"
        :color="config.alert"
        dark
        >
          <strong>{{ error.message }}</strong>
        </v-alert>
        <v-card-text class="">
          <v-form
            @submit.prevent="login"
            name="login-form"
            autocomplete="off">
            <v-text-field
              id="email"
              prepend-icon="mdi-email"
              label="Email"
              v-model="user.email"
              class="mb-3"
            ></v-text-field>
            <v-text-field
              id="password"
              prepend-icon="mdi-lock"
              label="Password"
              type="password"
              v-model="user.password"
              autocomplete="new-password"
              class="mb-3"
            ></v-text-field>
            <v-flex class="d-flex">
              <v-btn
                dark
                class="text-center"
                v-bind:color="config.primary"
                :loading="loading"
                type="submit">
                Login
              </v-btn>
              <div class="pa-2 ml-auto" >
                Don't have an account? Register <a @click="navigateTo('register')"> here </a>
                <br>
                <a @click="navigateTo('forgotpassword')">Forgot Password</a>
              </div>
            </v-flex>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import AuthService from '@/services/AuthService'
import config from '@/config/config'
export default {
  name: 'login',
  data () {
    return {
      user: {
        email: '',
        password: ''
      },
      error: null,
      config,
      loading: false,
    }
  },
  methods: {
    login () {
      this.loading = true
      if (this.user.email != '' && this.user.password != '') {
        AuthService.login(this.user).then((response) => {
          if (response.status == 200) {
            this.error = null
            this.$store.dispatch('login', response.data)
            this.$router.push({name: 'created'})
            this.loading = false
          } else {
            this.error = {message: 'A fatal error has occured'}
            this.loading = false
          }
        }).catch((error) => {
          this.error = error.response.data
          this.loading = false
        });
      } else {
        this.loading = false
        this.error = {message: 'Please fill in all of the fields'}
      }
    },
    navigateTo (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>

</style>